/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {FC} from 'react'
import {toAbsoluteUrl} from '../../../../../../../_metronic/helpers'
import {Company} from '../../core/_models'

type Props = {
  user: Company
}

const CompanyInfoCell: FC<Props> = ({user}) => (
  <div className='d-flex align-items-center'>
    {/* begin:: Avatar */}
    <div className='symbol symbol-circle symbol-40px overflow-hidden me-3'>
      <a href='#'>
        <div className='symbol-label'>
          <img
            src={toAbsoluteUrl(`/media/avatars/icons8-company-48.png`)}
            alt={user.name}
            className='w-50'
          />
        </div>
        
      </a>
    </div>
    <div className='d-flex flex-column'>{user.name}</div>
  </div>
)

export {CompanyInfoCell}
